import { useUniversalNavigationContext } from '@fff-web/fff-global-nav';

// eslint-disable-next-line react/display-name
const withUniversalNavigationContext = (WrappedComponent) => (props) => {
  const universalNavigationContext = useUniversalNavigationContext();
  return <WrappedComponent universalNavigationContext={universalNavigationContext} {...props} />;
};

export default withUniversalNavigationContext;
